import React from 'react';
import {StyledButton} from './styles';

const Button = ({children, type = 'filled', width = 'fit-content', onClick}) => {
    return (
        <StyledButton onClick={onClick} buttonType={type} width={width}
                      disabled={type === 'disabled'}>
            {children}
        </StyledButton>
    );
};

export default Button;
